import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login.vue'//登录
import Api from '../Serves/net-api.js'
import Http from '../Serves/net-http.js'
import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store/modules/store.js'
import Home from '../components/Home.vue'//首页
import HoneIdex from '../components/Index/home.vue'
import SubsidiesMonitor from '../components/Subsidies/PositioningMonitor.vue' //应用补贴
import PositioningMonitor from '../components/Index/PositioningMonitor.vue'
import Monitor from '../components/TableList/Monitor.vue'
import MachMonitor from '../components/TableList/MachMonitor.vue'
import ToolDistributionHeat from '../components/TableList/ToolDistributionHeat.vue' //机具分布热力图
import ToolStatistics from '../components/TableList/ToolStatistics.vue' //各省联网机具统计
import WorkHeatMap from '../components/TableList/WorkHeatMap.vue' //实时作业热力图
import ToolWorkProgress from '../components/TableList/ToolWorkProgress.vue' //机具作业进度
import ToolWorkTrend from '../components/TableList/ToolWorkTrend.vue' //机具作业趋势
import ToolWorkRank from '../components/TableList/ToolWorkRank.vue' //作业排行榜
import WarningEquipment from '../components/TableList/WarningEquipment.vue' //预警机具
import SpanningArea from '../components/TableList/SpanningArea.vue'
import DiscountDetails from '../components/TableList/DiscountDetails.vue'
import Warning from '../components/TableList/Warning.vue'
/*import  Satellite from '../components/Satellite/SateItem.vue'//卫星地图*/
import  Satellite from '../components/Satellite/TSateItem.vue'//卫星地图
/*import RecordItem from'../components/Record/RecordItem.vue'//轨迹回放*/
import RecordItem from'../components/Record/TRecordItem.vue'//轨迹回放
import TodayRecordItem from'../components/Record/TodayRecordItem.vue'//今日轨迹回放
/*import LocalRecord from'../components/Local/LocalRecord.vue'//历史轨迹*/
import LocalRecord from'../components/Local/TLocalRecord.vue'//历史轨迹
import Discount from '../components/TableList/Discount.vue'
import MonitorDetails from '../components/TableList/MonitorDetails.vue'
import AreaDetails from '../components/TableList/AreaDetails.vue'

import SubsidyDetails from '../components/TableList/SubsidyDetails.vue'
import DiscountSubsidys from '../components/TableList/DiscountSubsidy.vue'
import WarningSubsidy from '../components/TableList/WarningSubsidy.vue'
import SpanningAreaSubsidy from '../components/TableList/SpanningAreaSubsidy.vue'
import HarvestStatistics from '../components/TableList/HarvestStatistics.vue' // 早稻收获统计

import MachineryDistribution from '../components/MachineryDistribution/MachineryDistribution.vue' // 农机分布
import MachineryWorkArea from '../components/MachineryDistribution/MachineryWorkArea.vue' // 作业统计
import AllowanceStockList from '../components/MachineryDistribution/AllowanceStockList.vue' // 农机查询
import CrossAreaList from '../components/MachineryDistribution/CrossAreaList.vue' // 跨区管理
import NjDiscountDetails from '../components/MachineryDistribution/NjDiscountDetails.vue'
import MachineMonitor from '../components/MachineryDistribution/machineMonitor.vue'  //农机监管
import MachineMonitorList from '../components/MachineryDistribution/MachineMonitorList.vue'
import AreaSupervisionList from '../components/MachineryDistribution/AreaSupervisionList.vue'
import OperationDurationList from '../components/MachineryDistribution/OperationDurationList.vue'

// 减排农机
import MachineryNav from '../components/MachineryDistribution/MachineryNav.vue'
import MachineryStock from '../components/MachineryDistribution/MachineryStock.vue'
import JobSubsidy from '../components/MachineryDistribution/JobSubsidy.vue'
import DiscountSubsidy from '../components/MachineryDistribution/DiscountSubsidy.vue'
import MachineTar from '../components/MachineryDistribution/MachineTar.vue'
import TimeDistribution from '../components/MachineryDistribution/TimeDistribution.vue'
import ToolDistribution from '../components/MachineryDistribution/ToolDistribution.vue'

import WheatHarvest from '../components/WheatHarvest/index.vue' //麦收
import MapForPic from '../components/mapForPic.vue' //麦收


Vue.use(Router)
const option=[
  {
    path :'/MapForPic',
    name: 'MapForPic',
    component:MapForPic,
  },
  {
    path :'/Login',
    name: 'Login',
    component:Login
  },
  // 手机端
  // {
  //   path: '/mobile/login',
  //   name: 'mobile/login',
  //   component: ()=>import("@/components/mobile/login"),
  // },
  // {
  //   path: '/mobile/mine',
  //   name: 'mobile/mine',
  //   component: ()=>import("@/components/mobile/mine"),
  // },
  // {
  //   path: '/mobile/footerNav',
  //   name: 'mobile/footerNav',
  //   component: ()=>import("@/components/mobile/footerNav"),
  // },
  // {
  //   path: '/mobile/MachineryPage',
  //   name: 'mobile/MachineryPage',
  //   component: ()=>import("@/components/mobile/MachineryPage"),
  // },
  // {
  //   path: '/mobile/MachineryPage2',
  //   name: 'mobile/MachineryPage2',
  //   component: ()=>import("@/components/mobile/MachineryPage2"),
  // },
  // {
  //   path: '/mobile/historyWork',
  //   name: 'mobile/historyWork',
  //   component: ()=>import("@/components/mobile/historyWork"),
  // },
  // {
  //   path: '/mobile/workRecord',
  //   name: 'mobile/workRecord',
  //   component: ()=>import("@/components/mobile/workRecord"),
  // },
  {
    path :'/',
    name: 'Home',
    component:Home,
    children: [
      //Home,homeindex排查过
      {
        path :'/Home',
        name: 'HoneIdex',
        component:HoneIdex
      },
      {
        path :'/',
        name: 'HoneIdex',
        component:HoneIdex
      },
      {
        path :'/positioning-monitor',
        name: 'PositioningMonitor',
        component: PositioningMonitor
      },
      {
        path :'/subsidie-monitor',
        name: 'SubsidiesMonitor',
        component: SubsidiesMonitor
      },

      {
        path :'/Monitor',
        name: 'Monitor',
        component:Monitor,
        meta:{
          keepAlive:true
        }
      },
      {
        path :'/MachMonitor',
        name: 'MachMonitor',
        component:MachMonitor,
        meta:{
          keepAlive:true
        }
      },
      {
        path :'/ToolDistributionHeat',
        name: 'ToolDistributionHeat',
        component:ToolDistributionHeat,
      },
      {
        path :'/ToolStatistics',
        name: 'ToolStatistics',
        component:ToolStatistics,
      },
      {
        path :'/WorkHeatMap',
        name: 'WorkHeatMap',
        component:WorkHeatMap,
      },
      {
        path :'/ToolWorkProgress',
        name: 'ToolWorkProgress',
        component:ToolWorkProgress,
      },
      {
        path :'/ToolWorkTrend',
        name: 'ToolWorkTrend',
        component:ToolWorkTrend,
      },
      {
        path :'/ToolWorkRank',
        name: 'ToolWorkRank',
        component:ToolWorkRank,
      },
      {
        path :'/WarningEquipment',
        name: 'WarningEquipment',
        component:WarningEquipment,
      },
      {
        path :'/Satellite',
        name: 'Satellite',
        component:Satellite,
      },
      {
        path :'/SpanningArea',
        name: 'SpanningArea',
        component:SpanningArea
      },
      {
        path :'/AreaDetails',
        name: 'AreaDetails',
        component: AreaDetails,
        meta:{
          keepAlive:false
        }
      },
      {
        path :'/DiscountDetails',
        name: 'DiscountDetails',
        component:DiscountDetails,
        meta:{
          keepAlive:false
        }
      },
      {
        path :'/Warning',
        name: 'Warning',
        component:Warning
      },
      {
        path :'/Discount',
        name: 'Discount',
        component:Discount
      },
      {
        path :'/DiscountSubsidys',
        name: 'DiscountSubsidys',
        component:DiscountSubsidys
      },
      {
        path :'/WarningSubsidy',
        name: 'WarningSubsidy',
        component:WarningSubsidy
      },
      {
        path :'/HarvestStatistics',
        name: 'HarvestStatistics',
        component:HarvestStatistics,
      },
      {
        path :'/SpanningAreaSubsidy',
        name: 'SpanningAreaSubsidy',
        component:SpanningAreaSubsidy
      },
      {
        path :'/SubsidyDetails',
        name: 'SubsidyDetails',
        component:SubsidyDetails,
        meta:{
          keepAlive:false
        }
      },
      {
        path :'/MonitorDetails',
        name: 'MonitorDetails',
        component:MonitorDetails,
        meta:{
          keepAlive:false
        }
      },
      {
        path :'/LocalRecord',
        name: 'LocalRecord',
        component:LocalRecord,
      },
      {
        path :'/RecordItem',
        name: 'RecordItem',
        component:RecordItem,
      },
      {
        path :'/TodayRecordItem',
        name: 'TodayRecordItem',
        component:TodayRecordItem,
      },
      {
        path: '/machinery-distribution',
        name: 'MachineryDistribution',
        component: MachineryDistribution
      },
      {
        path: '/nj/machinery-area-statistics',
        name: 'MachineryWorkArea',
        component: MachineryWorkArea
      },
      {
        path: '/nj/allowance-stock-list',
        name: 'AllowanceStockList',
        component: AllowanceStockList,
        meta:{
          keepAlive:true
        }
      },
      {
        path: '/nj/big-data/cross-area',
        name: 'CrossAreaList',
        component: CrossAreaList,
        meta:{
          keepAlive:true
        }
      },
      {
        path:'/nj/discount_details',
        name: 'NjDiscountDetails',
        component: NjDiscountDetails,
        meta: {
          keepAlive:false
        }
      },
      {
        path: '/nj/big-data/machine-monitor',
        name: 'MachineMonitor',
        component: MachineMonitor
      },
      {
        path: '/Machine-monitor-list',
        name: 'MachineMonitorList',
        component: MachineMonitorList,
        meta:{
          keepAlive:true
        }
      },
      {
        path: '/Area-supervision-list',
        name: 'AreaSupervisionList',
        component: AreaSupervisionList,
        meta:{
          keepAlive:true
        }
      },
      {
        path: '/Operation-duration-list',
        name: 'OperationDurationList',
        component: OperationDurationList,
        meta:{
          keepAlive:true
        }
      },
      {
        path :'/MachineryNav',
        name: 'MachineryNav',
        component:MachineryNav,
      },
      {
        path :'/MachineryStock',
        name: 'MachineryStock',
        component:MachineryStock,
      },
      {
        path: '/JobSubsidy',
        name: 'JobSubsidy',
        component:JobSubsidy
      },
      {
        path :'/DiscountSubsidy',
        name: 'DiscountSubsidy',
        component:DiscountSubsidy,
      },
      {
        path :'/MachineTar',
        name: 'MachineTar',
        component:MachineTar
      },
      {
        path :'/TimeDistribution',
        name: 'TimeDistribution',
        component:TimeDistribution
      },
      {
        path :'/ToolDistribution',
        name: 'ToolDistribution',
        component:ToolDistribution
      },
      {
        path :'/WheatHarvest',
        name: 'WheatHarvest',
        component:WheatHarvest,
      },


    ]
  }
]
const router=new Router({
  mode:'history',
  base: '/view/',
  scrollBehavior: () => ({ y: 0 }),
  routes:option
})
router.beforeEach((to, from, next) => {
  // if(to.path == "/MapForPic" || window.location.href.indexOf("MapForPic")>0){
  //   next()
  // }
  // debugger;
  if (to.path === '/U2VyY2V0IjpudWxsLCJpc0VuYWJsZSI6MSwiaXNEZWwiOjAsInJlc291cmNlcyI6W10sInJ') {
    var token = 'Bearer 3ab38b53-5661-4f3e-b2cc-dd38b127b1ab'
    localStorage.setItem('token', token)
    let token =localStorage.getItem( "token")
    console.log(token)
    if (token) {
      next({ path: '/' })
    }
    // next()
  } else {
    // 获取地址栏中参数
    function getParameter (param) {
      var query = window.location.search;
      var iLen = param.length;
      var iStart = query.indexOf(param);
      if (iStart === -1) {
        return '';
      }
      iStart += iLen + 1;
      var iEnd = query.indexOf('?', iStart);
      if (iEnd === -1) {
        return query.substring(iStart);
      }
      return query.substring(iStart, iEnd);
    }
    var userInfo = getParameter('userInfo')// userInfo：浙政钉用户请求的URL后会拼接
    // 查询浙江 浙政钉用户是否在农机物联网系统绑定用户关系
    if (userInfo !== '' && to.path === '/') {
      axios.get(Http.userVerify + '?userInfo=' + userInfo).then((res) => {
        if (res.data.code === 1) {
          var token = res.data.result.token
          localStorage.setItem('token', token)
          if (token) {
            next()
          }
        } else if (res.data.code === 150) { // code是150的时候 跳转到等于页面用户登录会自动绑定关系. unionid拼接到登录url后面
          localStorage.clear()
          localStorage.removeItem('token')
          Message({
            message: res.data.message,
            type: 'warning'
          });
          var unionid = res.data.result.unionid // 判断浙政钉用户是否绑定物联网用户关系接口
          localStorage.setItem('unionid', unionid)
          if(window.location.host === 'zhejiang.dtwl360.com') {
            if (localStorage.getItem('unionid') === '' || localStorage.getItem('unionid') === null) {
              window.location.href = 'https://zhejiang.dtwl360.com/adm/user/login'
            } else {
              window.location.href = 'https://zhejiang.dtwl360.com/adm/user/login?unionid=' + localStorage.getItem('unionid')
            }
          } else {
            next()
          }
        }
      }).catch(function(errs){
        console.log(errs)
      })
    } else {
      function _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
        );
        return flag;
      }
      if (localStorage.getItem( "token")) {
        // next()
        if (to.path === '/Login' || to.path === '/mobile/login') {
          var url=Http.test+'/logout'
          Api.doPost(url,null, false, (res) => {
            localStorage.clear()
            // next({ path: '/Login' })
            if (_isMobile()) {
              // 手机端
              next({ path: "/mobile/login"})
            } else {
              // pc端
              next({ path: '/Login' })
            }
          })
        } else {
          next()
        }
      }
      // else if(to.path == "/MapForPic" || window.location.href.indexOf("MapForPic")>0){
      //   next()
      // }
      else {
        let token =localStorage.getItem( "token")
        if (!token ||  token === 'null' || token === '') {
          // Router.push({path: '/Login'})
          // next({ path: '/Login' })
          if (_isMobile()) {
            // 手机端
            next({ path: "/mobile/login"})
          } else {
            // pc端
            // next({ path: '/Login' })
            
            if (window.location.host === 'beijing.dtwl360.com') {
              window.location.href = 'https://beijing.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'chongqing.dtwl360.com') {
              window.location.href = 'https://chongqing.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'fujian.dtwl360.com') {
              window.location.href = 'https://fujian.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'henan.dtwl360.com') {
              window.location.href = 'https://henan.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'taiwan.dtwl360.com') {
              window.location.href = 'https://taiwan.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'shandong.dtwl360.com') {
              window.location.href = 'https://shandong.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'xjbt.dtwl360.com') {
              window.location.href = 'https://xjbt.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'ningxia.dtwl360.com') {
              window.location.href = 'https://ningxia.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'qingdao.dtwl360.com') {
              window.location.href = 'https://qingdao.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'jiangxi.dtwl360.com') {
              window.location.href = 'https://jiangxi.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'hunan.dtwl360.com') {
              window.location.href = 'https://hunan.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'hebei.dtwl360.com') {
              window.location.href = 'https://hebei.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'gansu.dtwl360.com') {
              window.location.href = 'https://gansu.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'national.dtwl360.com') {
              window.location.href = 'https://national.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'neimeng.dtwl360.com') {
              window.location.href = 'https://neimeng.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'xiamen.dtwl360.com') {
              window.location.href = 'https://xiamen.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'ningbo.dtwl360.com') {
              window.location.href = 'https://ningbo.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'jiangsu.dtwl360.com') {
              if(window.location.href.indexOf("MapForPic")>0 ){
                next()
              } else {
                window.location.href = 'https://jiangsu.dtwl360.com/adm/user/login'
              }
            } else if(window.location.host === 'xinjiang.dtwl360.com') {
              window.location.href = 'https://xinjiang.dtwl360.com/adm/user/login'
            } else if (window.location.host === 'guangdong.dtwl360.com') {
              window.location.href = 'https://guangdong.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'zhejiang.dtwl360.com') {
              // console.log(localStorage.getItem('unionid'))
              if (localStorage.getItem('unionid') === '' || localStorage.getItem('unionid') === null) {
                window.location.href = 'https://zhejiang.dtwl360.com/adm/user/login'
              } else {
                window.location.href = 'https://zhejiang.dtwl360.com/adm/user/login?unionid=' + localStorage.getItem('unionid')
              }
            } else if(window.location.host === 'tianjin.dtwl360.com') {
              window.location.href = 'https://tianjin.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'guangxi.dtwl360.com') {
              window.location.href = 'https://guangxi.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'hubei.dtwl360.com') {
              window.location.href = 'https://hubei.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'anhui.dtwl360.com') {
              window.location.href = 'https://anhui.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'qinghai.dtwl360.com') {
              window.location.href = 'https://qinghai.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'bdh.dtwl360.com') {
              window.location.href = 'https://bdh.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'sichuan.dtwl360.com') {
              window.location.href = 'https://sichuan.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'huaxia.dtwl360.com') {
              window.location.href = 'https://huaxia.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'sx.dtwl360.com') {
              window.location.href = 'https://sx.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'liaoning.dtwl360.com') {
              window.location.href = 'https://liaoning.dtwl360.com/adm/user/login'
            } else if(window.location.host === 'yunnan.dtwl360.com') {
              window.location.href = 'https://yunnan.dtwl360.com/adm/user/login'
            } else {
              // next({ path: '/Login' })
              next()
              // if(window.location.href.indexOf("MapForPic")>0 ){
              //   next()
              // } else {
              //   window.location.href = 'http://jiangsu.dtwl360.com/adm/user/login'
              // }
            }
          }
        } else {
          next()
        }
      }
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/Router/index.js